import * as Constants from "../constants";
import * as InitialStates from "../constants/initialStates";

const mapLiveFeedbackQuestions = (data) =>
  data?.length
    ? data.map(({ id, question, order, questionType }) => ({
        id: parseInt(id, 10),
        question,
        order,
        questionType,
      }))
    : [];

export default function liveFeedbackQuestionsReducer(
  state = InitialStates.getInitialLiveFeedbackQuestionsState(),
  action
) {
  switch (action?.type) {
    case Constants.GET_LIVE_FEEDBACK_QUESTIONS:
      return {
        ...InitialStates.getInitialLiveFeedbackQuestionsState(),
        loading: true,
      };
    case Constants.GET_LIVE_FEEDBACK_QUESTIONS_SUCCESS: {
      const data = action.payload.liveFeedbackQuestions;
      return {
        ...InitialStates.getInitialLiveFeedbackQuestionsState(),
        liveFeedbackQuestionsFetched: true,
        liveFeedbackQuestions: mapLiveFeedbackQuestions(data),
      };
    }
    case Constants.GET_LIVE_FEEDBACK_QUESTIONS_ERROR: {
      return {
        ...InitialStates.getInitialLiveFeedbackQuestionsState(),
        errorFetching: true,
      };
    }
    default:
      return state;
  }
}
